module.exports = __webpack_public_path__ + "images/evbox_small698731f213c5b611651587dbb0b08a22.png";